import { Link } from "react-router-dom";
import { Shield } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import LegalGate from "@/components/legal/LegalGate";
import AgreementsHistory from "@/components/legal/AgreementsHistory";

export default function AccountLegal() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) {
    return (
      <div className="max-w-xl mx-auto px-6 py-16 text-center" data-testid="account-legal-signin">
        <p className="text-slate-600">Sign in to see your Terms & Conditions and privacy choices.</p>
        <Link to="/login" className="pf-btn-primary inline-block mt-4 px-6 py-2.5 rounded-full text-sm font-semibold">Sign in</Link>
      </div>
    );
  }
  const actor = user.role === "merchant" ? "MERCHANT" : "SHOPPER";
  return (
    <div className="max-w-4xl mx-auto px-5 sm:px-8 py-10" data-testid="account-legal-page">
      <LegalGate actor={actor}>
        <div className="pf-chip pf-chip-lav"><Shield className="w-3 h-3" /> Account · Terms &amp; Privacy</div>
        <h1 className="font-display text-4xl sm:text-5xl text-slate-900 mt-3">Terms &amp; Privacy</h1>
        <p className="text-sm text-slate-600 mt-2 mb-6">Your Terms & Conditions history, Privacy Notice acknowledgement and marketing preference.</p>
        <AgreementsHistory showMarketing />
      </LegalGate>
    </div>
  );
}
